// https://github.com/sampotts/plyr

import plyr from 'plyr';
import 'plyr/dist/plyr.css';

const videoPlayer = () => {
  const players = plyr.setup(
    '#player', {
      debug: true,
      controls: [
        'airplay',
        'captions',
        'current-time',
        'fullscreen',
        'mute',
        'play',
        'play-large',
        'progress',
        'volume',
      ],
      hideControls: false,
    },
  );

  players.forEach((player) => {
    player.on('play', () => {
      const others = players.filter((other) => other !== player);
      others.forEach((other) => {
        other.pause();
      });
    });
  });
};

export default videoPlayer;
